import {gql} from '@apollo/client';

// The review queue, as built in news-service ff6c97a (update to the plan, §3).
// A story from a website not set to publish without review is held here as a
// draft. `article` is the whole draft as a WebsiteNewsInput, both languages.

export const GET_NEWS_DRAFTS = gql`
  query NewsDrafts(
    $exchangeId: ID
    $status: NewsDraftStatus
    $sourceId: ID
    $search: String
    $limit: Int
    $page: Int
  ) {
    newsDrafts(
      exchangeId: $exchangeId
      status: $status
      sourceId: $sourceId
      search: $search
      limit: $limit
      page: $page
    ) {
      ... on Error {
        message
      }
      ... on NewsDraftList {
        pagination {
          page
          pages
          total
        }
        data {
          id
          status
          title
          language
          createdAt
          heldBecause
          requestedBy
          sources {
            outlet
          }
        }
      }
    }
  }
`;

export const GET_NEWS_DRAFT = gql`
  query NewsDraft($draftId: ID!) {
    newsDraft(draftId: $draftId) {
      ... on Error {
        message
      }
      ... on NewsDraft {
        id
        status
        exchangeId
        createdAt
        title
        language
        heldBecause
        requestedBy
        article
        companyMentions {
          name
          ticker
        }
        sources {
          articleId
          outlet
          title
          url
        }
        publishedWebsiteNewsId
        publishedWithEdits
        reviewedAt
        rejectReason
        rejectNote
      }
    }
  }
`;

// Without `data` the draft publishes as written. With it, the editor's
// version replaces the draft whole.
export const APPROVE_NEWS_DRAFT = gql`
  mutation ApproveNewsDraft($draftId: ID!, $data: WebsiteNewsInput) {
    approveNewsDraft(draftId: $draftId, data: $data) {
      ... on Error {
        message
        statusCode
      }
      ... on NewsDraft {
        id
        status
        publishedWebsiteNewsId
      }
    }
  }
`;

export const REJECT_NEWS_DRAFT = gql`
  mutation RejectNewsDraft(
    $draftId: ID!
    $reason: NewsDraftRejectReason!
    $note: String
  ) {
    rejectNewsDraft(draftId: $draftId, reason: $reason, note: $note) {
      ... on Error {
        message
      }
      ... on NewsDraft {
        id
        status
      }
    }
  }
`;
